<script>
export default {
  props: {
    options: {
      type: Array,
      required: true
    },
    selected: {
      type: Number,
      required: true
    }
  }
}
</script>

<template>
  <div
    class="toggle"
    :style="{
      '--current-selected': selected,
      '--total-itens': options.length.toString(),
    }"
  >
    <button
      v-for="(option, index) in options"
      :key="index"
      class="toggle__button"
      :class="{ 'toggle__button--active': index === selected }"
      @click.prevent="$emit('toggle', index)"
    >
      {{ option }}
    </button>
  </div>
</template>

<style lang="scss">
@import "~@/style/ui/variables";

.toggle {
  --transition-time: 0.3s;

  background-color: #fff;
  border-radius: 28px;
  font-family: $rubik-font-family;

  display: flex;
  position: relative;

  &::before {
    background-color: $color-purple-heart;
    border-radius: 28px;
    bottom: 0;
    content: "";
    left: calc(100% / var(--total-itens) * var(--current-selected));
    position: absolute;
    top: 0;
    transition: left var(--transition-time) linear;
    width: calc(100% / var(--total-itens));
    z-index: 0;
  }

  &__button {
    color: #76767A;
    cursor: pointer;
    flex: 1;
    font-size: 16px;
    line-height: 24px;
    padding: 8px 18px;
    position: relative;
    transition: color var(--transition-time) linear,
      font-weight var(--transition-time) linear;
    z-index: var(--z-index-1);

    &--active {
      color: #fff;
      font-weight: 700;
    }
  }
}
</style>
